"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BirthdayField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Error = _interopRequireDefault(require("../Error"));
var _validateBirthday = require("../../utils/validateBirthday");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var BirthdayField = function BirthdayField(_ref) {
  var errorMessage = _ref.errorMessage,
    label = _ref.label,
    format = _ref.format,
    lang = _ref.lang,
    onChange = _ref.onChange,
    onError = _ref.onError;
  var locale = lang;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    initialState = _useState2[0],
    setInitialState = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    errorText = _useState4[0],
    setErrorText = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    formattedBirthday = _useState6[0],
    setFormattedBirthday = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFocused = _useState8[0],
    setFocus = _useState8[1];
  (0, _react.useEffect)(function () {
    if (!initialState) {
      // validate birthday
      if ((0, _validateBirthday.isBirthdayValid)(formattedBirthday, locale)) {
        onChange(formattedBirthday);
        setErrorText("");
        onError(false);
        return;
      }
      setErrorText(errorMessage);
      onError(true);
      setFocus(false);
    }
  }, [formattedBirthday, errorMessage, onError, onChange, locale, initialState]);
  var formatBirthday = function formatBirthday() {
    // format birthday
    var cleanedBirthday = formattedBirthday.trim().replace(/\//gi, "");
    var slashedBirthday = cleanedBirthday.slice(0, 2) + "/" + cleanedBirthday.slice(2, 4) + "/" + cleanedBirthday.slice(4, cleanedBirthday.length);
    setFormattedBirthday(slashedBirthday);
  };
  var handleChange = function handleChange(event) {
    event.preventDefault();
    setInitialState(false);
    setFocus(true);
    setFormattedBirthday(event.target.value);
  };
  var handleBlur = function handleBlur() {
    setInitialState(false);
    // set error message if empty
    if (!formattedBirthday) {
      setErrorText(errorMessage);
      return;
    }
    // format birthday
    formatBirthday();
  };
  var handleFocus = function handleFocus(event) {
    event.preventDefault();
    setInitialState(false);
    setFocus(true);
    setErrorText("");
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "birthday-field"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "birthdate",
    className: isFocused || formattedBirthday ? "floating" : ""
  }, label), /*#__PURE__*/_react.default.createElement("input", {
    key: "birthdate-input",
    type: "text",
    id: "birthdate",
    name: "birthdate",
    value: formattedBirthday,
    placeholder: !isFocused ? "" : format,
    onFocus: function onFocus(event) {
      return handleFocus(event);
    },
    onChange: function onChange(event) {
      return handleChange(event);
    },
    onBlur: function onBlur() {
      return handleBlur();
    },
    className: errorText ? "error" : ""
  }), errorText && /*#__PURE__*/_react.default.createElement(_Error.default, {
    error: errorText
  }));
};
exports.BirthdayField = BirthdayField;
var _default = BirthdayField;
exports.default = _default;